
import React from 'react';
import { FormField } from '@/components/dashboard/shops/types';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { PhoneInputField } from './PhoneInputField';

interface FormFieldComponentProps {
  field: FormField;
  valueSetterPair: {
    value: any;
    setter: (value: any) => void;
  } | null;
}

const FormFieldComponent: React.FC<FormFieldComponentProps> = ({ field, valueSetterPair }) => {
  if (!valueSetterPair) {
    console.error(`No value/setter pair found for field: ${field.name}`);
    return null;
  }

  const { value, setter } = valueSetterPair;
  
  console.log(`Rendering field: ${field.name}, type: ${field.type}, value: ${value}`);

  return (
    <div className="space-y-2">
      <Label htmlFor={field.id} className="text-sm font-medium">
        {field.label} {field.required && <span className="text-red-500">*</span>}
      </Label>

      {field.type === 'text' && (
        <Input
          id={field.id}
          name={field.name}
          type="text"
          placeholder={`Entrez ${field.label.toLowerCase()}`}
          value={value || ''}
          onChange={(e) => setter(e.target.value)}
          required={field.required}
        />
      )}

      {field.type === 'phone' && (
        <PhoneInputField
          id={field.id}
          name={field.name}
          value={value || ''}
          onChange={(e) => setter(e.target.value)}
          required={field.required}
        />
      )}

      {field.type === 'email' && (
        <Input
          id={field.id}
          name={field.name}
          type="email"
          placeholder="exemple@email.com"
          value={value || ''}
          onChange={(e) => setter(e.target.value)}
          required={field.required}
        />
      )}

      {field.type === 'textarea' && (
        <Textarea
          id={field.id}
          name={field.name}
          placeholder={`Entrez ${field.label.toLowerCase()}`}
          value={value || ''}
          onChange={(e) => setter(e.target.value)}
          required={field.required}
        />
      )}

      {field.type === 'select' && (
        <Input
          id={field.id}
          name={field.name}
          type="text"
          placeholder={`Sélectionnez ${field.label.toLowerCase()}`}
          value={value || ''}
          onChange={(e) => setter(e.target.value)}
          required={field.required}
        />
      )}
    </div>
  );
};

export default FormFieldComponent;
